module.exports = __webpack_public_path__ + "static/assets/58dc6e48da751ce222bdae8c1414299a.gif";